import React from 'react';
import usePageTitle from '../../hooks/usePageTitle';
import { Link } from 'react-router-dom';
import MenuMobilePublic from './MenuMobilePublic';
import { KaneaLogo } from '../../components/Common/KaneaLogo';
import { ArrowLeft } from 'lucide-react';
import CalculatorsSection from './CalculatorsSection';

const OutilsPage: React.FC = () => {
  usePageTitle("Calculateurs pour investisseurs BRVM");
  return (
    <div style={{ minHeight: '100vh', background: 'var(--lp-bg)', color: 'var(--lp-text)' }}>

      {/* ── NAV ── */}
      <nav className="landing-nav">
        <Link to="/home" className="landing-nav-logo">
          <KaneaLogo variant="horizontal" title="KaneaBourse" markColor="#6C3FC4" textColor="var(--lp-text)" height={28} />
          <div className="landing-nav-logo-dot" />
        </Link>

        <ul className="landing-nav-links">
          <li><Link to="/home#features">Fonctionnalités</Link></li>
          <li><Link to="/home#tarifs">Tarifs</Link></li>
          <li><Link to="/blog">Publications</Link></li>
          <li><Link to="/help">Centre d'aide</Link></li>
        </ul>

        <div className="landing-nav-actions">
          <Link to="/login" className="btn-nav-login">Se connecter</Link>
          <Link to="/members/signup" className="btn-nav-signup">Compte gratuit</Link>
          <MenuMobilePublic liens={[{ label: "Fonctionnalités", to: '/home#features' }, { label: "Tarifs", to: '/home#tarifs' }, { label: "Publications", to: '/blog' }, { label: "Centre d'aide", to: '/help' }]} />
        </div>
      </nav>

      {/* ── HEADER ── */}
      <div style={{ maxWidth: 860, margin: '0 auto', padding: '88px 20px 0' }}>
        <Link
          to="/home"
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            fontSize: 13, fontWeight: 600, color: '#6C3FC4', textDecoration: 'none',
            background: 'rgba(108,63,196,0.08)', border: '1px solid rgba(108,63,196,0.2)',
            padding: '7px 14px', borderRadius: 8, marginBottom: 28,
          }}
        >
          <ArrowLeft size={14} /> Retour à l'accueil
        </Link>

        <div className="landing-section-label" style={{ marginBottom: 10 }}>Outils gratuits</div>
        <h1 style={{ fontSize: 'clamp(1.8rem, 4vw, 2.8rem)', fontWeight: 900, margin: '0 0 12px', color: 'var(--lp-heading)', lineHeight: 1.15 }}>
          Calculateurs pour investisseurs BRVM
        </h1>
        <p style={{ fontSize: '1rem', color: 'var(--lp-text-muted)', maxWidth: 560, margin: 0, lineHeight: 1.7 }}>
          Des outils simples et concrets pour évaluer vos investissements sur la Bourse Régionale des Valeurs Mobilières.
          Aucun compte requis.
        </p>
      </div>

      {/* ── CALCULATEURS ── */}
      <CalculatorsSection />

      {/* ── CTA ── */}
      <div style={{ textAlign: 'center', padding: '40px 20px 80px' }}>
        <p style={{ fontSize: 14, color: 'var(--lp-text-muted)', marginBottom: 16 }}>
          Vous voulez aller plus loin ? Accédez aux valorisations réelles des 48 titres BRVM.
        </p>
        <Link to="/members/signup" className="btn-primary-lg" style={{ display: 'inline-flex' }}>
          Créer un compte gratuit →
        </Link>
      </div>

      {/* ── FOOTER ── */}
      <footer className="landing-footer">
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', gap: 16 }}>
          <div className="landing-footer-copy">
            © {new Date().getFullYear()} KaneaBourse — Tous droits réservés
          </div>
          <div className="landing-footer-links" style={{ display: 'flex', gap: 16 }}>
            <Link to="/terms">Conditions d'utilisation</Link>
            <Link to="/confidentialite">Confidentialité</Link>
            <a href="mailto:contact@kaneabourse.com">Contact</a>
            <a href="https://www.brvm.org" target="_blank" rel="noopener noreferrer">BRVM</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default OutilsPage;
